import React, { useState, useRef, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleRight, faArrowCircleLeft } from "@fortawesome/pro-light-svg-icons";
import theme from "../../theme/theme";
import { Box } from "@mui/system";
import { Button, Fade, Skeleton, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const InfoCarousel = ({ slides, loading }) => {

    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const element = document.getElementById("info-carousel");
            if (element) {
                const rect = element.getBoundingClientRect();
                const isVisible = rect.top < window.innerHeight && rect.bottom >= 0;
                setIsVisible(isVisible);
            }
        };

        window.addEventListener("scroll", handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        }
    }, []);

    const [currentSlide, setCurrentSlide] = useState(0);
    const sliderRef = useRef(null);

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
    };

    const goToPrevSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPrev();
            setCurrentSlide(currentSlide - 1);
        }
    };

    const goToNextSlide = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext();
            setCurrentSlide(currentSlide + 1);
        }
    };

    return (
        <>
            <Box
                sx={{
                    position: "relative",
                }}
                id="info-carousel"
            >
                { loading ?
                    <Box
                        sx={{
                            position: "relative",
                            minHeight: "700px",
                            width: "100%",
                            background: "#f5f5f5",
                        }}
                    >
                        <Skeleton
                            variant="rectangular"
                            sx={{
                                position: "absolute",
                                left: "4%",
                                top: "70px",
                                width: {
                                    xs: "92%",
                                    sm: "50%",
                                    lg: "35%",
                                },
                                height: "250px",
                                padding: "60px 100px 40px 60px",
                            }}
                        />
                        <Skeleton
                            variant="rectangular"
                            sx={{
                                position: "absolute",
                                right: {
                                    xs: "50%",
                                    sm: "4%",
                                },
                                bottom: {
                                    xs: "230px",
                                    sm: "300px",
                                },
                                transform: {
                                    xs: "translateX(50%)",
                                    sm: "translateX(0%)",
                                },
                                width: "200px",
                                height: "50px",
                                borderRadius: "50px",
                            }}
                        />
                    </Box>
                : slides && slides.length > 0 ?
                    <Slider {...settings} ref={sliderRef}>
                        {slides.map((slide, index) => {
                            return (
                                <Fade in={isVisible} timeout={1000}>
                                    <Box
                                        key={index}
                                        sx={{
                                            position: "relative",
                                            minHeight: {
                                                xs: "860px",
                                                md: "750px",
                                            },
                                            backgroundImage: `url(${slide.slide_image})`,
                                            backgroundSize: "cover",
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                width: '92%',
                                                height: '100%',
                                                maxWidth: `${theme.width.maxwidth}`,
                                                left: '50%',
                                                transform: 'translate(-50%)',
                                            }}
                                        >
                                            <Fade in={isVisible} timeout={2000}>
                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: "70px",
                                                        width: {
                                                            xs: "92%",
                                                            sm: "50%",
                                                            md: "50%",
                                                            lg: "37%",
                                                        },
                                                        ml:{
                                                            xs: "4%",
                                                        },
                                                        backgroundColor: "rgba(256,256,256,0.9)",
                                                        padding:'2rem 3rem 3rem 3rem',
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            alignItems: "center",
                                                            justifyContent: "space-between",
                                                            width: "75px",
                                                            marginBottom: "20px",
                                                        }}
                                                    >
                                                        <FontAwesomeIcon
                                                            icon={faArrowCircleLeft}
                                                            style={{
                                                                color: "#005EAA",
                                                                fontSize: "1.5rem",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={goToPrevSlide}
                                                        />
                                                        <FontAwesomeIcon
                                                            icon={faArrowCircleRight}
                                                            style={{
                                                                color: "#005EAA",
                                                                fontSize: "1.5rem",
                                                                cursor: "pointer",
                                                            }}
                                                            onClick={goToNextSlide}
                                                        />
                                                    </Box>
                                                    <Typography
                                                        variant="h4"
                                                        sx={{
                                                            color: "#E9531C",
                                                            fontWeight: "600",
                                                            fontSize: "1.5rem",
                                                        }}
                                                    >
                                                        {slide.slide_title}
                                                    </Typography>
                                                    <Box
                                                        dangerouslySetInnerHTML={{
                                                            __html: slide.slide_content,
                                                        }}
                                                    />
                                                </Box>
                                            </Fade>
                                            <Fade in={isVisible} timeout={3000}>
                                                <Button
                                                    sx={{
                                                        position: "absolute",
                                                        right: {
                                                            xs: "50%",
                                                            sm: "0%",
                                                        },
                                                        bottom: {
                                                            xs: "25%",
                                                            sm: "50%",
                                                        },
                                                        transform: {
                                                            xs: "translateX(50%)",
                                                            sm: "translateX(0%)",
                                                        },
                                                        backgroundColor:"#E9531C",
                                                        color: "#ffffff",
                                                        borderRadius: "50px",
                                                        fontWeight: "600",
                                                        fontSize:'1rem',
                                                        padding: "0.5rem 1rem",
                                                        textAlign: "center",
                                                        '&:hover': {
                                                            backgroundColor: "#2a5da5",
                                                        },
                                                        transition: "background-color 0.3s ease-in-out",
                                                    }}
                                                    component={RouterLink}
                                                    to={slide.slide_button_link}
                                                >
                                                    {slide.slide_button_text}
                                                </Button>
                                            </Fade>
                                        </Box>
                                    </Box>
                                </Fade>
                            );
                        })}
                    </Slider>
                : null }
            </Box>
        </>
    );
};

export default InfoCarousel;
